<div class="datagridsidebar__header">
    <div class="tabsschedular__action">
        @if (cxSchedularService.currentScreen === SCREENS.TWO) {
            <span (click)="cxSchedularService.currentScreen = SCREENS.ONE" class="hand"><i class="fa fa-arrow-left"></i></span>
        }
        <h2>Scheduler</h2>
    </div>
    <div class="sidebar__action schedular--action">
        @if (cxSchedularService.scheduals.length > 0 && cxSchedularService.currentScreen === SCREENS.ONE) {
            <button class="btn-bg" (click)="cxSchedularService.currentScreen = SCREENS.TWO; cxSchedularService.editMode = true;">Create New</button>
        }
        @if (!cxSchedularService.editMode && cxSchedularService.currentScreen === SCREENS.TWO) {
            <button class="btn-bg btn--light" (click)="cxSchedularService.editMode = true">Edit</button>
        }
        <!-- <button class="btn-bg btn--light" (click)=" onClose()">Cancel</button> -->
    </div>
</div>


<div class="schedular-container">
    @if (cxSchedularService.currentScreen === SCREENS.ONE) {
        <cx-schedular-list [module]="module"></cx-schedular-list>
    } @else if (cxSchedularService.currentScreen === SCREENS.TWO) {
        <cx-schedular-creator
            [views]="views"    
            [module]="module">
        </cx-schedular-creator>
    }
</div>

@if (cxSchedularService.scheduals.length === 0 && cxSchedularService.currentScreen === SCREENS.ONE) {
    <div class="empty-filter-container">
        There are no schedules.
        <div class="text-center" style="margin-top: 10px;">
            <button class="btn-bg" (click)="cxSchedularService.currentScreen = SCREENS.TWO; cxSchedularService.editMode = true;">Create New</button>
        </div>
    </div>
}